import createComponent from '../../../util/create-component';
import moduleA from '../../../store/moduleA';
import App from './App.vue';

export default createComponent('componentA', App, { moduleA });
